/*eslint-disable*/
import React from "react";
import SelectInput from "../../components/select_input/SelectInput";
import { Link } from "react-router-dom";

const ScorecardGive = ({
  selectedApp,
  showBusinessVideoTooltip, setShowBusinessVideoTooltip,
  showMissionTooltip, setShowMissionTooltip,
  showImpactTooltip, setShowImpactTooltip,
  showLocationUsageTooltip, setShowLocationUsageTooltip,
  showChallengeTooltip, setShowChallengeTooltip,
  showFundingTooltip, setShowFundingTooltip,
  showEventsTooltip, setShowEventsTooltip,
  showVolunteerTooltip, setShowVolunteerTooltip,
  showOverallImpactTooltip, setShowOverallImpactTooltip,
  showMembersAwardedTooltip, setShowMembersAwardedTooltip,
  handleChange,
  scorecardOPTIONS,
  orgAmountOPTIONS,
  handleAnnualAward,
  amount
}) => {
  return (
    <div className="mt-6 mb-4 w-full space-y-6 bg-gray-50 p-6 rounded-lg shadow-md">
      {/* Business Video*/}
      <div className="w-full relative bg-white rounded-lg p-4 shadow-sm mb-7">
        <label
          htmlFor="businessVideo"
          className="text-lg font-semibold text-gray-800 block mb-2"
        >
          Record a Business Video (3 minutes or less)
        </label>
        <div className="mt-1">
          {selectedApp?.businessVideo && selectedApp?.businessVideo !== "N/A" ? (
            <Link
              className="underline text-blue-600 hover:text-blue-800 transition"
              to={selectedApp.businessVideo}
              target="_blank"
            >
              {selectedApp.businessVideo}
            </Link>
          ) : (
            <span className="text-gray-600">
              No business video available for this application.
            </span>
          )}
        </div>
        <label
          htmlFor="scoreBusinessVideo"
          className="block text-md font-semibold text-gray-800 mb-2 relative mt-4"
        >
          Business Video Score (0 OR 3 Scale)
          <button
            type="button"
            className="ml-2 text-danger-500 font-bold hover:text-red-500 focus:outline-none focus:ring-2 focus:ring-red-600"
            onClick={() => setShowBusinessVideoTooltip(true)}
          >
            ?
          </button>
          {showBusinessVideoTooltip && (
            <div className="absolute left-0 mt-2 w-96 bg-white p-4 border border-gray-300 rounded-lg shadow-lg z-50 animate-fadeIn max-h-60 overflow-y-auto">
              <button
                type="button"
                className="absolute top-2 right-2 text-danger-500 hover:text-danger-500 focus:outline-none"
                onClick={() => setShowBusinessVideoTooltip(false)}
              >
                X
              </button>
              <h4 className="font-semibold mb-2 text-gray-900">
                Business Video Score Guide:
              </h4>
              <ul className="list-none text-gray-700 space-y-4">
                {[
                  {
                    score: 0,
                    text: "No video submitted.",
                  },
                  {
                    score: 3,
                    text: "Thorough video presenting a clear narrative of the business.",
                  },
                ].map(({ score, text }) => (
                  <li key={score} className="text-gray-800 flex items-start space-x-3">
                    <div className="bg-gray-200 text-success-800 font-semibold h-8 w-8 flex items-center justify-center rounded-full">
                      {score}
                    </div>
                    <p className="text-md font-normal">{text}</p>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </label>

        <SelectInput
          className="block w-full mt-2 px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary-400 focus:border-primary-400 sm:text-md"
          options={scorecardOPTIONS.filter(
            (option) => option.value === 0 || option.value === 3
          )} // Filter to show only 0 and 3
          placeholder={
            selectedApp?.scoreBusinessVideo != null
              ? selectedApp.scoreBusinessVideo
              : "Select a score"
          }
          defaultValue={
            selectedApp?.scoreBusinessVideo != null
              ? selectedApp.scoreBusinessVideo
              : undefined
          }
          setSelectedValue={(evt) => handleChange("scoreBusinessVideo", evt.value)}
        />
      </div>


      {/* Organization Mission */}
      <div className="w-full relative bg-white rounded-lg p-4 shadow-sm">
        <label
          htmlFor="orgMission"
          className="block text-md font-semibold text-gray-800 mb-2"
        >
          Description of Your Organization and Mission:
        </label>
        <textarea
          disabled
          className="block w-full px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:ring focus:ring-primary-300 bg-gray-100"
          defaultValue={selectedApp?.orgMission}
          rows="4"
        />
        <label htmlFor="scoreMission" className="block text-md font-semibold text-gray-800 mb-2 relative">
          Clear Mission (1-3 Scale)
          <button
            type="button"
            className="ml-2 text-danger-500 font-bold hover:text-red-500 focus:outline-none focus:ring-2 focus:ring-red-600"
            onClick={() => setShowMissionTooltip(true)}
          >
            ?
          </button>
          {showMissionTooltip && (
            <div className="absolute left-0 mt-2 w-96 bg-white p-4 border border-gray-300 rounded-lg shadow-lg z-50 animate-fadeIn max-h-60 overflow-y-auto">
              <button
                type="button"
                className="absolute top-2 right-2 text-danger-500 hover:text-danger-500 focus:outline-none"
                onClick={() => setShowMissionTooltip(false)}
              >
                X
              </button>
              <h4 className="font-semibold mb-2 text-gray-900">Clear Mission Score Guide:</h4>
              <ul className="list-none text-gray-700 space-y-2">
                <li className="text-gray-800 font-normal">
                  <span className="text-gray-900">0 - </span>
                  <p>
                    <strong>Clarity:</strong> Vision and mission statements are vague or absent.
                  </p>
                  <p>
                    <strong>Alignment:</strong> There is no clear connection between the organization's activities and the vision or mission.
                  </p>
                </li>
                <li className="text-gray-800 font-normal">
                  <span className="text-gray-900">1 - </span>
                  <p>
                    <strong>Clarity:</strong> Vision and mission statements are somewhat unclear or lacking in specific details.
                  </p>
                  <p>
                    <strong>Alignment:</strong> There is a limited connection between the organization's activities and the vision or mission.
                  </p>
                </li>
                <li className="text-gray-800 font-normal">
                  <span className="text-gray-900">2 - </span>
                  <p>
                    <strong>Clarity:</strong> Vision and mission statements are clear and understandable.
                  </p>
                  <p>
                    <strong>Alignment:</strong> There is a general connection between the organization's activities and the vision or mission.
                  </p>
                </li>
                <li className="text-gray-800 font-normal">
                  <span className="text-gray-900">3 - </span>
                  <p>
                    <strong>Clarity:</strong> Vision and mission statements are clear, concise, and specific.
                  </p>
                  <p>
                    <strong>Alignment:</strong> There is a strong connection between the organization's activities and the vision or mission.
                  </p>
                </li>
              </ul>
            </div>
          )}
        </label>

        <SelectInput
          className="block w-full mt-2 px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary-400 focus:border-primary-400 sm:text-md"
          options={scorecardOPTIONS} // or filter if needed
          placeholder={
            selectedApp?.scoreMission != null
              ? selectedApp.scoreMission
              : "Select a score" // default placeholder if null
          }
          defaultValue={
            selectedApp?.scoreMission != null
              ? selectedApp.scoreMission
              : undefined // no pre-selected value if null
          }
          setSelectedValue={(evt) => handleChange("scoreMission", evt.value)}
        />
      </div>

      {/* Community Impact */}
      <div className="w-full relative bg-white rounded-lg p-4 shadow-sm">
        <label
          htmlFor="orgImpact"
          className="block text-md font-semibold text-gray-800 mb-2"
        >
          How does your organization impact the local community?
        </label>
        <textarea
          disabled
          className="block w-full px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:ring focus:ring-primary-300 bg-gray-100"
          defaultValue={selectedApp?.orgImpact}
          rows="4"
        />
        <label htmlFor="scoreImpact" className="block text-md font-semibold text-gray-800 mb-2">
          Community Impact (1-3 Scale)
          <button
            type="button"
            className="ml-2 text-danger-500 font-bold hover:text-red-500 focus:outline-none focus:ring-2 focus:ring-red-600"
            onClick={() => setShowImpactTooltip(true)}
          >
            ?
          </button>
          {showImpactTooltip && (
            <div className="absolute left-0 mt-2 w-96 bg-white p-4 border border-gray-300 rounded-lg shadow-lg z-50 animate-fadeIn max-h-60 overflow-y-auto">
              <button
                type="button"
                className="absolute top-2 right-2 text-danger-500 hover:text-danger-500 focus:outline-none"
                onClick={() => setShowImpactTooltip(false)}
              >
                X
              </button>
              <h4 className="font-semibold mb-2 text-gray-900">Community Impact Guide:</h4>
              <ul className="list-none text-gray-700 space-y-2">
                <li className="text-gray-800 font-normal">
                  <span className="text-gray-900">0 - </span>
                  <p>
                    <strong>Scope:</strong>  The nonprofit's activities do not reach the community or serve only a very limited group.
                  </p>
                  <p>
                    <strong>Depth:</strong> No measurable changes in community outcomes or quality of life are observed.
                  </p>
                </li>
                <li className="text-gray-800 font-normal">
                  <span className="text-gray-900">1 - </span>
                  <p>
                    <strong>Scope:</strong> The nonprofit's activities have a minimal reach, impacting only a small portion of the community.
                  </p>
                  <p>
                    <strong>Depth:</strong>  Measurable changes are limited in scale, with little lasting improvement in community outcomes or quality of life.
                  </p>
                </li>
                <li className="text-gray-800 font-normal">
                  <span className="text-gray-900">2 - </span>
                  <p>
                    <strong>Scope:</strong>  The nonprofit's activities reach a moderate portion of the community, impacting multiple groups or areas.
                  </p>
                  <p>
                    <strong>Depth:</strong> The nonprofit's efforts lead to measurable changes in community outcomes or quality of life, though they may not be consistent across the entire community.
                  </p>
                </li>
                <li className="text-gray-800 font-normal">
                  <span className="text-gray-900">3 - </span>
                  <p>
                    <strong>Scope:</strong> The nonprofit's activities have a broad reach, impacting a large portion of the community or addressing key community needs.
                  </p>
                  <p>
                    <strong>Depth:</strong> The nonprofit's efforts lead to significant and measurable changes in community outcomes, with noticeable improvements in quality of life.

                  </p>
                </li>
              </ul>
            </div>
          )}
        </label>
        <SelectInput
          className="block w-full mt-2 px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary-400 focus:border-primary-400 sm:text-md"
          options={scorecardOPTIONS}
          placeholder={
            selectedApp?.scoreImpact != null
              ? selectedApp.scoreImpact
              : "Select a score" // fallback when null
          }
          defaultValue={
            selectedApp?.scoreImpact != null
              ? selectedApp.scoreImpact
              : undefined // no pre-selected value if null
          }
          setSelectedValue={(evt) => handleChange("scoreImpact", evt.value)}
        />
      </div>

      {/* Location Usage */}
      <div className="w-full relative bg-white rounded-lg p-4 shadow-sm">
        <label
          htmlFor="locationUsage"
          className="block text-md font-semibold text-gray-800 mb-2"
        >
          How are you planning to use our location?
        </label>
        <textarea
          disabled
          className="block w-full px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:ring focus:ring-primary-300 bg-gray-100"
          defaultValue={selectedApp?.locationUsage}
          rows="4"
        />
        <label htmlFor="scoreLocationUsage" className="block text-md font-semibold text-gray-800 mb-2 relative">
          Usage Engagement Score (0-3 Scale)
          <button
            type="button"
            className="ml-2 text-danger-500 font-bold hover:text-red-500 focus:outline-none focus:ring-2 focus:ring-red-600"
            onClick={() => setShowLocationUsageTooltip(true)}
          >
            ?
          </button>
          {showLocationUsageTooltip && (
            <div className="absolute left-0 mt-2 w-96 bg-white p-4 border border-gray-300 rounded-lg shadow-lg z-50 animate-fadeIn max-h-60 overflow-y-auto">
              <button
                type="button"
                className="absolute top-2 right-2 text-danger-500 hover:text-danger-500 focus:outline-none"
                onClick={() => setShowLocationUsageTooltip(false)}
              >
                X
              </button>
              <h4 className="font-semibold mb-2 text-gray-900">Usage Engagement Score Guide:</h4>
              <ul className="list-none text-gray-700 space-y-4">
                {[
                  {
                    score: 0,
                    text: "No plan to utilize the location."
                  },
                  {
                    score: 1,
                    text: "Coworking with a desire for community and connection. Mostly internal organization engagement."
                  },
                  {
                    score: 2,
                    text: "Coworking with a desire for community and connection with the hope of hosting meetings in our space."
                  },
                  {
                    score: 3,
                    text: "Desire for full engagement in coworking, community, meetings, and events. Bringing people into the space."
                  }
                ].map(({ score, text }) => (
                  <li key={score} className="flex items-start space-x-3 text-gray-800">
                    <div className="bg-gray-200 text-success-800 font-semibold h-8 w-8 flex items-center justify-center rounded-full">
                      {score}
                    </div>
                    <p className="text-md font-normal">{text}</p>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </label>

        <SelectInput
          className="block w-full mt-2 px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary-400 focus:border-primary-400 sm:text-md"
          options={scorecardOPTIONS}
          placeholder={
            selectedApp?.scoreLocationUsage != null
              ? selectedApp.scoreLocationUsage
              : "Select a score" // fallback if null
          }
          defaultValue={
            selectedApp?.scoreLocationUsage != null
              ? selectedApp.scoreLocationUsage
              : undefined // no pre-selected value if null
          }
          setSelectedValue={(evt) => handleChange("scoreLocationUsage", evt.value)}
        />
      </div>

      {/* Organization's Top Three Challenges */}
      <div className="w-full relative bg-white rounded-lg p-4 shadow-sm">
        <label
          htmlFor="threeChallenges"
          className="block text-md font-semibold text-gray-800 mb-2"
        >
          What are your organization's top three challenges or barriers?
        </label>
        <textarea
          disabled
          className="block w-full px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:ring focus:ring-primary-300 bg-gray-100"
          defaultValue={selectedApp?.threeChallenges}
          rows="4"
        />
        <label htmlFor="scoreChallenges" className="block text-md font-semibold text-gray-800 mb-2 relative">
          Challenge Removal Score (0-3 Scale)
          <button
            type="button"
            className="ml-2 text-danger-500 font-bold hover:text-red-500 focus:outline-none focus:ring-2 focus:ring-red-600"
            onClick={() => setShowChallengeTooltip(true)}
          >
            ?
          </button>
          {showChallengeTooltip && (
            <div className="absolute left-0 mt-2 w-96 bg-white p-4 border border-gray-300 rounded-lg shadow-lg z-50 animate-fadeIn max-h-60 overflow-y-auto">
              <button
                type="button"
                className="absolute top-2 right-2 text-danger-500 hover:text-danger-500 focus:outline-none"
                onClick={() => setShowChallengeTooltip(false)}
              >
                X
              </button>
              <h4 className="font-semibold mb-2 text-gray-900">Challenge Removal Score Guide:</h4>
              <ul className="list-none text-gray-700 space-y-4">
                {[
                  {
                    score: 0,
                    text: "List none."
                  },
                  {
                    score: 1,
                    text: "List one out of three that could potentially be removed by the COhatch ecosystem."
                  },
                  {
                    score: 2,
                    text: "List two of three challenges that could potentially be removed by the COhatch ecosystem."
                  },
                  {
                    score: 3,
                    text: "List three out of three challenges that could potentially be removed by the COhatch ecosystem."
                  }
                ].map(({ score, text }) => (
                  <li key={score} className="text-gray-800 flex items-start space-x-3">
                    <div className="bg-gray-200 text-success-800 font-semibold h-8 w-8 flex items-center justify-center rounded-full">
                      {score}
                    </div>
                    <p className="text-md font-normal">{text}</p>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </label>

        <SelectInput
          className="block w-full mt-2 px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary-400 focus:border-primary-400 sm:text-md"
          options={scorecardOPTIONS}
          placeholder={
            selectedApp?.scoreChallenges != null
              ? selectedApp.scoreChallenges
              : "Select a score" // fallback if null
          }
          defaultValue={
            selectedApp?.scoreChallenges != null
              ? selectedApp.scoreChallenges
              : undefined // no pre-selected value if null
          }
          setSelectedValue={(evt) => handleChange("scoreChallenges", evt.value)}
        />
      </div>

      {/* Organization Funding */}
      <div className="w-full relative bg-white rounded-lg p-4 shadow-sm">
        <label
          htmlFor="funding"
          className="block text-md font-semibold text-gray-800 mb-2"
        >
          How is your organization funded?
        </label>
        <textarea
          disabled
          className="block w-full px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:ring focus:ring-primary-300 bg-gray-100"
          defaultValue={selectedApp?.funding}
          rows="4"
        />
        <label htmlFor="scoreFunding" className="block text-md font-semibold text-gray-800 mb-2 relative">
          Funding Plan Score (0-3 Scale)
          <button
            type="button"
            className="ml-2 text-danger-500 font-bold hover:text-red-500 focus:outline-none focus:ring-2 focus:ring-red-600"
            onClick={() => setShowFundingTooltip(true)}
          >
            ?
          </button>
          {showFundingTooltip && (
            <div className="absolute left-0 mt-2 w-96 bg-white p-4 border border-gray-300 rounded-lg shadow-lg z-50 animate-fadeIn max-h-60 overflow-y-auto">
              <button
                type="button"
                className="absolute top-2 right-2 text-danger-500 hover:text-danger-500 focus:outline-none"
                onClick={() => setShowFundingTooltip(false)}
              >
                X
              </button>
              <h4 className="font-semibold mb-2 text-gray-900">Funding Plan Score Guide:</h4>
              <ul className="list-none text-gray-700 space-y-4">
                {[
                  {
                    score: 0,
                    text: "None"
                  },
                  {
                    score: 1,
                    text: "No clear plan, fundraiser only."
                  },
                  {
                    score: 2,
                    text: "Fundraising and partners."
                  },
                  {
                    score: 3,
                    text: "Sustainable plan."
                  }
                ].map(({ score, text }) => (
                  <li key={score} className="text-gray-800 flex items-start space-x-3">
                    <div className="bg-gray-200 text-success-800 font-semibold h-8 w-8 flex items-center justify-center rounded-full">
                      {score}
                    </div>
                    <p className="text-md font-normal">{text}</p>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </label>

        <SelectInput
          className="block w-full mt-2 px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary-400 focus:border-primary-400 sm:text-md"
          options={scorecardOPTIONS}
          placeholder={
            selectedApp?.scoreFunding != null
              ? selectedApp.scoreFunding
              : "Select a score" // fallback if null
          }
          defaultValue={
            selectedApp?.scoreFunding != null
              ? selectedApp.scoreFunding
              : undefined // no pre-selected value if null
          }
          setSelectedValue={(evt) => handleChange("scoreFunding", evt.value)}
        />
      </div>

      {/* Annual Events */}
      <div className="w-full relative bg-white rounded-lg p-4 shadow-sm">
        <label
          htmlFor="annualEvents"
          className="block text-md font-semibold text-gray-800 mb-2"
        >
          Does your organization have any annual events? If so, please tell us about your events.
        </label>
        <textarea
          disabled
          className="block w-full px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:ring focus:ring-primary-300 bg-gray-100"
          defaultValue={selectedApp?.annualEvents}
          rows="4"
        />
        <label htmlFor="scoreEvents" className="block text-md font-semibold text-gray-800 mb-2 relative">
          Events Score (0-3 Scale)
          <button
            type="button"
            className="ml-2 text-danger-500 font-bold hover:text-red-500 focus:outline-none focus:ring-2 focus:ring-red-600"
            onClick={() => setShowEventsTooltip(true)}
          >
            ?
          </button>
          {showEventsTooltip && (
            <div className="absolute left-0 mt-2 w-96 bg-white p-4 border border-gray-300 rounded-lg shadow-lg z-50 animate-fadeIn max-h-60 overflow-y-auto">
              <button
                type="button"
                className="absolute top-2 right-2 text-danger-500 hover:text-danger-500 focus:outline-none"
                onClick={() => setShowEventsTooltip(false)}
              >
                X
              </button>
              <h4 className="font-semibold mb-2 text-gray-900">Events Score Guide:</h4>
              <ul className="list-none text-gray-700 space-y-4">
                {[
                  {
                    score: 0,
                    text: "None"
                  },
                  {
                    score: 1,
                    text: "Not currently but is interested."
                  },
                  {
                    score: 2,
                    text: "Currently has an annual event in other locations."
                  },
                  {
                    score: 3,
                    text: "Has a variety of events and COhatch is a possible location."
                  }
                ].map(({ score, text }) => (
                  <li key={score} className="text-gray-800 flex items-start space-x-3">
                    <div className="bg-gray-200 text-success-800 font-semibold h-8 w-8 flex items-center justify-center rounded-full">
                      {score}
                    </div>
                    <p className="text-md font-normal">{text}</p>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </label>

        <SelectInput
          className="block w-full mt-2 px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary-400 focus:border-primary-400 sm:text-md"
          options={scorecardOPTIONS}
          placeholder={
            selectedApp?.scoreEvents != null
              ? selectedApp.scoreEvents
              : "Select a score" // fallback if null
          }
          defaultValue={
            selectedApp?.scoreEvents != null
              ? selectedApp.scoreEvents
              : undefined // no pre-selected value if null
          }
          setSelectedValue={(evt) => handleChange("scoreEvents", evt.value)}
        />
      </div>

      {/* Volunteer Usage */}
      <div className="w-full relative bg-white rounded-lg p-4 shadow-sm">
        <label
          htmlFor="volunteers"
          className="block text-md font-semibold text-gray-800 mb-2"
        >
          Does your organization use volunteers? If so, tell us how?
        </label>
        <textarea
          disabled
          className="block w-full px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:ring focus:ring-primary-300 bg-gray-100"
          defaultValue={selectedApp?.volunteers}
          rows="4"
        />
        <label htmlFor="scoreVolunteers" className="block text-md font-semibold text-gray-800 mb-2 relative">
          Volunteer Engagement Score (0-3 Scale)
          <button
            type="button"
            className="ml-2 text-danger-500 font-bold hover:text-red-500 focus:outline-none focus:ring-2 focus:ring-red-600"
            onClick={() => setShowVolunteerTooltip(true)}
          >
            ?
          </button>
          {showVolunteerTooltip && (
            <div className="absolute left-0 mt-2 w-96 bg-white p-4 border border-gray-300 rounded-lg shadow-lg z-50 animate-fadeIn max-h-60 overflow-y-auto">
              <button
                type="button"
                className="absolute top-2 right-2 text-danger-500 hover:text-danger-500 focus:outline-none"
                onClick={() => setShowVolunteerTooltip(false)}
              >
                X
              </button>
              <h4 className="font-semibold mb-2 text-gray-900">Volunteer Engagement Score Guide:</h4>
              <ul className="list-none text-gray-700 space-y-4">
                {[
                  {
                    score: 0,
                    text: "None"
                  },
                  {
                    score: 1,
                    text: " Yes. One opportunity a year."
                  },
                  {
                    score: 2,
                    text: "One to two opportunities that could engage members."
                  },
                  {
                    score: 3,
                    text: "Multiple opportunities for member volunteer activation."
                  }
                ].map(({ score, text }) => (
                  <li key={score} className="text-gray-800 flex items-start space-x-3">
                    <div className="bg-gray-200 text-success-800 font-semibold h-8 w-8 flex items-center justify-center rounded-full">
                      {score}
                    </div>
                    <p className="text-md font-normal">{text}</p>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </label>

        <SelectInput
          className="block w-full mt-2 px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary-400 focus:border-primary-400 sm:text-md"
          options={scorecardOPTIONS}
          placeholder={
            selectedApp?.scoreVolunteers != null
              ? selectedApp.scoreVolunteers
              : "Select a score" // fallback if null
          }
          defaultValue={
            selectedApp?.scoreVolunteers != null
              ? selectedApp.scoreVolunteers
              : undefined // no pre-selected value if null
          }
          setSelectedValue={(evt) => handleChange("scoreVolunteers", evt.value)}
        />
      </div>

      {/* Overall Application Impact */}
      <div className="w-full relative bg-white rounded-lg p-4 shadow-sm">
        <label htmlFor="scoreImpact" className="block text-md font-semibold text-gray-800 mb-2 relative">
          Overall Application Impact Score (0-3 Scale)
          <button
            type="button"
            className="ml-2 text-danger-500 font-bold hover:text-red-500 focus:outline-none focus:ring-2 focus:ring-red-600"
            onClick={() => setShowOverallImpactTooltip(true)}
          >
            ?
          </button>
          {showOverallImpactTooltip && (
            <div className="absolute left-0 mt-2 w-96 bg-white p-4 border border-gray-300 rounded-lg shadow-lg z-50 animate-fadeIn max-h-60 overflow-y-auto">
              <button
                type="button"
                className="absolute top-2 right-2 text-danger-500 hover:text-danger-500 focus:outline-none"
                onClick={() => setShowOverallImpactTooltip(false)}
              >
                X
              </button>
              <h4 className="font-semibold mb-2 text-gray-900">Impact Score Guide:</h4>
              <ul className="list-none text-gray-700 space-y-2">
                <li className="text-gray-800 font-normal">
                  <span className="text-gray-900">3 - </span>
                  <p>
                    <strong>Impact:</strong> Applicant is unprecedentedly challenging established norms and approaches. Certain to generate insight and/or significant impact.
                  </p>
                </li>
                <li className="text-gray-800 font-normal">
                  <span className="text-gray-900">2 - </span>
                  <p>
                    <strong>Impact:</strong> Applicant is challenging established norms and approaches in the community. Creating insight and significant tangible impact.
                  </p>
                </li>
                <li className="text-gray-800 font-normal">
                  <span className="text-gray-900">1 - </span>
                  <p>
                    <strong>Impact:</strong> Applicant builds and is working on improving the community through new insight and tangible impact.
                  </p>
                </li>
                <li className="text-gray-800 font-normal">
                  <span className="text-gray-900">0 - </span>
                  <p>
                    <strong>Impact:</strong> Applicant relies exclusively on a solo approach and does not involve any community involvement or new insight.
                  </p>
                </li>
              </ul>
            </div>
          )}
        </label>

        <SelectInput
          className="block w-full mt-2 px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary-400 focus:border-primary-400 sm:text-md"
          options={scorecardOPTIONS}
          placeholder={
            selectedApp?.scoreOverallAppImpact != null
              ? selectedApp.scoreOverallAppImpact
              : "Select a score" // fallback if null
          }
          defaultValue={
            selectedApp?.scoreOverallAppImpact != null
              ? selectedApp.scoreOverallAppImpact
              : undefined // no pre-selected value if null
          }
          setSelectedValue={(evt) => handleChange("scoreOverallAppImpact", evt.value)}
        />
      </div>

      {/* Total Score */}
      <div className="w-full bg-white rounded-lg p-4 shadow-sm">
        <label
          htmlFor="score"
          className="block text-md font-semibold text-gray-800 mb-2"
        >
          Total Score (24 maximum)


        </label>
        <input
          disabled
          className="block w-full px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 bg-gray-100"
          name="score"
          id="score"
          placeholder={
            (selectedApp?.scoreOverallAppImpact || 0) +
            (selectedApp?.scoreVolunteers || 0) +
            (selectedApp?.scoreEvents || 0) +
            (selectedApp?.scoreFunding || 0) +
            (selectedApp?.scoreChallenges || 0) +
            (selectedApp?.scoreLocationUsage || 0) +
            (selectedApp?.scoreImpact || 0) +
            (selectedApp?.scoreMission || 0)
          }
        />
      </div>


      {/* # of Team Members Applying for Scholarship */}
      <div className="w-full relative bg-white rounded-lg p-4 shadow-sm">
        <label
          htmlFor="teamMembersApplying"
          className="block text-md font-semibold text-gray-800 mb-2"
        >
          # of Team Members Applying for Scholarship
        </label>
        <input
          type="number"
          disabled
          className="block w-full px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 bg-gray-100"
          placeholder={selectedApp?.orgAmount}
        />

        {/* # of Team Members Awarded Scholarship */}

        <label
          htmlFor="awardedMembers"
          className="block text-md font-semibold text-gray-800 mb-2"
        >
          # of Team Members Awarded Scholarship (5 max)
          <button
            type="button"
            className="ml-2 text-danger-500 font-bold hover:text-red-500 focus:outline-none focus:ring-2 focus:ring-red-600"
            onClick={() => setShowMembersAwardedTooltip(true)}
          >
            ?
          </button>
          {showMembersAwardedTooltip && (
            <div className="absolute left-0 mt-2 w-96 bg-white p-4 border border-gray-300 rounded-lg shadow-lg z-50 animate-fadeIn max-h-60 overflow-y-auto">
              <button
                type="button"
                className="absolute top-2 right-2 text-danger-500 hover:text-danger-500 focus:outline-none"
                onClick={() => setShowMembersAwardedTooltip(false)}
              >
                X
              </button>
              <h4 className="font-semibold mb-2 text-gray-900">Volunteer Engagement Score Guide:</h4>
              <ul className="list-none text-gray-700 space-y-4">
                {[
                  {
                    score: 0,
                    text: "0 - 5 points - DECLINE"
                  },
                  {
                    score: 1,
                    text: "6 - 8 points (1-2 memberships)"
                  },
                  {
                    score: 2,
                    text: "16 points - 9 points (up to 3 memberships)"
                  },
                  {
                    score: 3,
                    text: "17 - 24 points (up to 5 memberships)"
                  }
                ].map(({ score, text }) => (
                  <li key={score} className="text-gray-800 flex items-start space-x-3">
                    <div className="bg-gray-200 text-success-800 font-semibold h-8 w-8 flex items-center justify-center rounded-full">
                      {score}
                    </div>
                    <p className="text-md font-normal">{text}</p>
                  </li>
                ))}
              </ul>
            </div>
          )}
        </label>
        <SelectInput
          className="block w-full mt-2 px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 focus:outline-none focus:ring-primary-400 focus:border-primary-400 sm:text-md"
          options={orgAmountOPTIONS}
          placeholder={
            selectedApp?.awardedMember != null
              ? selectedApp.awardedMember
              : selectedApp?.scoreMemAwarded != null
                ? selectedApp.scoreMemAwarded
                : "Select a value" // fallback if both are null
          }
          defaultValue={
            selectedApp?.awardedMember != null
              ? selectedApp.awardedMember
              : selectedApp?.scoreMemAwarded != null
                ? selectedApp.scoreMemAwarded
                : undefined
          }
          setSelectedValue={handleAnnualAward}
        />
      </div>

      {/* Annual Award */}
      <div className="w-full bg-white rounded-lg p-4 shadow-sm">
        <label
          htmlFor="awardAmount"
          className="block text-md font-semibold text-gray-800 mb-2"
        >
          Annual Award ($199 x member for 12 months)
        </label>
        <input
          disabled
          className="block w-full px-4 py-3 border border-gray-300 rounded-md shadow-sm placeholder-gray-400 bg-gray-100"
          type="awardAmount"
          name="awardAmount"
          id="awardAmount"
          value={amount}
          placeholder={selectedApp?.annualAward}
        />
      </div>
    </div>
  );
};

export default ScorecardGive;
